import React from "react";
import { updateConfig } from "State/Admin/AdminSettings/ConfigurationSlice";
import { useAppDispatch, useAppSelector } from "hooks";
import { RootState } from "State/store";

const EmailSettings: React.FC = () => {
  const dispatch = useAppDispatch();
  const config = useAppSelector((state: RootState) => state.configuration.config);

  return (
    <div className="font-body tracking-wider bg-white p-4 rounded-md border border-gray-200">
      <h4 className="text-xs font-medium text-gray-700 mb-3">Email Settings</h4>
      <div className="space-y-3">
        <div>
          <label
            htmlFor="to_email"
            className="block text-xs font-medium text-gray-700 mb-1"
          >
            Support / Contact Email
          </label>
          <input
            id="to_email"
            type="email"
            value={config.toEmail ?? ""}
            onChange={(e) => dispatch(updateConfig({ toEmail: e.target.value }))}
            placeholder="support@example.com"
            className="block w-full text-xs border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <p className="mt-1 text-[10px] text-gray-500">
            Contact form messages will be sent to this email address.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailSettings;
